import { runCsImport } from './CsImportStrategy';
import { runPlantUmlImport } from './PlantUmlImportStrategy';

/**
 * Registry of import strategies for UML schema import.
 * Each entry: {key, label, enabled, run, extensions}.
 * `extensions` drives file-drop grouping (UmlSchemaImportTab.jsx).
 */
export const IMPORT_STRATEGIES = [
  { key: 'csharp', label: 'C#', enabled: true, run: runCsImport, extensions: ['cs'] },
  { key: 'plantuml', label: 'PlantUML', enabled: true, run: runPlantUmlImport, extensions: ['puml', 'plantuml'] },
];

/**
 * @param {string} key
 * @returns {object|null}
 */
export function getImportStrategy(key) {
  return IMPORT_STRATEGIES.find(function matchKey(strategy) {
    return strategy.key === key;
  }) || null;
}

/**
 * Maps a filename's extension to a strategy key, for grouping dropped files.
 * @param {string} filename
 * @returns {string|null} strategy key, or null if no enabled strategy claims this extension
 */
export function getStrategyKeyForFilename(filename) {
  const ext = filename.split('.').pop().toLowerCase();
  const strategy = IMPORT_STRATEGIES.find(function matchExtension(s) {
    return s.enabled && s.extensions.includes(ext);
  });
  return strategy ? strategy.key : null;
}
